import React from 'react'

const Grid = ({ className = '', gutter = false, children }) => {
  const useGutter = gutter ? 'Grid--withGutter' : ''
  return <div className={`Grid ${useGutter} ${className}`}>{children}</div>
}

const GridItem = ({
  columnCount = '1',
  gridSize = '12',
  className,
  children,
}) => {
  const grid = `u-size${columnCount}of${gridSize}`

  return (
    <div className={`${[grid, className].join(' ').trim()}`}>{children}</div>
  )
}

export { Grid, GridItem }
